import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_inventory_transformation_source_line_total_by_inventory_transformation_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventory_transformation_id: number, include_status_ids?: number[], exclude_status_ids?: number[] }): 
  Promise<{ result: { total_packaged_amount?: number, InventoryTransformationId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventory_transformation_id)) {
      missingRequiredInParams.push('\'inventory_transformation_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformation_source_line_total_by_inventory_transformation_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventory_transformation_id: number, include_status_ids?: number[], exclude_status_ids?: number[]    }) {
        if(isNil(inParams.inventory_transformation_id)) {
          return true; 
        }
      return false;
    }
}
